import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "navbar-nav dropdown" }
const _hoisted_2 = {
  class: "nav-item btn border-top-0 border-gradient-glow-warning-bottom rounded-0 rounded-top dropdown-toggle d-flex align-items-center text-center text-md-start py-1 px-3 fs-5",
  type: "button",
  id: "language-switche-dropdown",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false",
  style: {"height":"56px"}
}
const _hoisted_3 = { class: "mx-3 text-capitalize" }
const _hoisted_4 = {
  class: "dropdown-menu",
  "aria-labelledby": "languageSwitcher"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "dropdown-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    _createElementVNode("li", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("i", { class: "bi bi-globe-americas text-warning" }, null, -1)),
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.locale), 1)
    ]),
    _createElementVNode("ul", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.supportedLocales, (sLocale) => {
        return (_openBlock(), _createElementBlock("li", {
          key: sLocale,
          onClick: ($event: any) => (_ctx.switchLanguage(sLocale)),
          style: {"cursor":"pointer"}
        }, [
          _createElementVNode("a", _hoisted_6, _toDisplayString(_ctx.getLangTranslit(sLocale)), 1)
        ], 8, _hoisted_5))
      }), 128))
    ])
  ]))
}